const setLabelFrequency = {
  onDemand: 'POR DEMANDA',
  month: 'mês',
  months: 'meses',
  day: 'dia',
  days: 'dias'
}

export default setLabelFrequency;
